export class GeoCityFilter {
  name?: string;
  regionId?: number;
  countryId?: number;
}

export class GeoRegionFilter {
  name?: string;
  countryId?: number;
}

export class GeoCountryFilter {
  name?: string;
}